import { FC, useState } from "react";
import Button from "~/components/Button";
import Checkbox from "~/components/Checkbox";
import Input from "~/components/Input";
import Text from "~/components/Text";
import Colors from "~/constants/colors";
import ModalContainer from "../ModalContainer";
import styles from "./CancelOrderModal.module.scss";

interface CancelOrderModalProps {
  open?: boolean;
  onClose?: () => void;
}

const CancelOrderModal: FC<CancelOrderModalProps> = ({ open, onClose }) => {
  const [reason, setReason] = useState("");

  return (
    <ModalContainer
      open={open}
      onClose={onClose}
      width={744}
      className={styles.cancel_order_modal}
      title="Why do you want to cancel order?"
      titleIcon="bag-cross"
      titleColor={Colors.GREY_900}
    >
      <div className={styles.content}>
        <Checkbox
          label="I want to update my delivery address/number"
          labelType="body-3"
          weight={400}
        />
        <Checkbox
          label="Seller did not respond to my inquiries/requests"
          labelType="body-3"
          weight={400}
        />
        <Checkbox
          label="Change order (color, size, add discount code, ...)"
          labelType="body-3"
          weight={400}
        />
        <Checkbox
          label="I don't need to buy anymore"
          labelType="body-3"
          weight={400}
        />
        <Checkbox
          align="start"
          className="!w-full"
          label={
            <div className="flex flex-col gap-3 w-full">
              <div className="flex justify-between gap-4">
                <Text type="body-3" color={Colors.GREY_800}>
                  Other reason
                </Text>
                <Text type="body-3" color={Colors.GREY_300}>
                  {reason.length}/{2000}
                </Text>
              </div>
              <Input
                placeholder="Type your comment about it..."
                value={reason}
                maxLength={2000}
                onChange={(e) => setReason(e.target.value)}
              />
            </div>
          }
        />
      </div>
      <Button
        className="md:max-w-[200px] w-full mx-auto"
        onClick={() => onClose?.()}
      >
        Cancel Order
      </Button>
    </ModalContainer>
  );
};

export default CancelOrderModal;
